import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import SessionCard from './SessionCard';
import { Typography } from '@material-ui/core';

const styles = theme => ({
    section: {
        [theme.breakpoints.up('md')]: {
            marginLeft: 330,
            fontSize: 18
        },
        marginBottom: 18,
        
        fontSize: 16,
    },
    container: {
        marginBottom: 40,
      },
    
    toolbar: theme.mixins.toolbar,
});

class EventSearch extends React.Component {


    
    onSetResult = (result) => {
        const values = queryString.parse(this.props.location.search);
        this.props.updateSearchResults(result);
        this.props.updateTitle('Search Results','for '+values.keyword,'',NaN,values.keyword);
    };

    componentWillMount() {
        const values = queryString.parse(this.props.location.search);
        if('keyword' in values && values.keyword.length > 0) {
            fetch("https://www.seatingsymposium.us/app/rest/presentations/search?keyword="+values.keyword).then(response => response.json()).then(result => this.onSetResult(result));
            this.props.updateTitle('Search Results','for '+values.keyword,'',NaN,values.keyword);
        }
        else {
            this.props.updateTitle('Search Results','','',NaN,'');
        }
        
    }

    componentWillUpdate({ location, history }) {
        const gtag = window.gtag;
        
        if (history.action === 'PUSH' && typeof(gtag) === 'function') {
          gtag('config', 'UA-115311410-1', {
            'page_location': window.location.href,
            'page_path': location.pathname,
          })
        }
      }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.displayLoadIndicator(false);
    }

    componentDidUpdate() {
        window.scrollTo(0, 0);
    }

    render() {
        const { classes,results,searchKeyword } = this.props;
        // console.log(searchKeyword);
        if (results.length === 0) {
            return (<Typography className={classes.section} variant="title" color="error">No presentations or posters found. Please try again.</Typography>)
        }
        
        return (
            <div>
                {results.map((item,itemKey) => {
                    return(
                        <div key={itemKey} className={classes.container}>
                            <Typography className={classes.section} variant="title" color="textSecondary">{item.formattedDay} ({item.nfstart} - {item.nfend})</Typography>
                            <SessionCard session={item} key={item.id+itemKey} searchKeyword={searchKeyword}/>
                        </div>
                    );
                })}
            </div>
        );
    }

}

EventSearch.propTypes = {
    updateTitle: PropTypes.func,
    displayLoadIndicator: PropTypes.func,
    updateSearchResults: PropTypes.func.isRequired,
    searchKeyword: PropTypes.string,
};

export default withRouter(withStyles(styles)(EventSearch));